import { ConnectCredentialConfig } from '../types/connect';

import { IConnectIntegration } from './integration.interface';
import { IPersona } from './persona.interface';
import { IProject } from './project.interface';

export interface IConnectCredential {
  id: string;
  projectId: string;
  integrationId: string;
  config: ConnectCredentialConfig;
  personaId: string;
  isPreviewCredential: boolean;

  /**
   * @property providerId : this property stores user's identifiers in third party database e.g. Shopify
   */
  providerId: string;
  dateCreated: Date;
  dateUpdated: Date;
  dateValidUntil?: Date;
  dateRefreshed: Date;
  status: CredentialStatus;
  /**
   * miscellaneous integration provider data received along with access_token/userinfo
   */
  providerData: ConnectCredentialProviderData;
  /**
   * count how many times credential failed to refresh
   */
  refreshFailureCount: number;

  /**
   * track refreshing status
   */
  isRefreshing: boolean;

  project?: IProject;
  integration?: IConnectIntegration;
  persona?: IPersona;
}

export type ConnectCredentialProviderData = Record<string, string | number | boolean>;

export enum CredentialStatus {
  PENDING = 'PENDING',
  INVALID = 'INVALID',
  VALID = 'VALID',
}